<template>
  <div
    id="user-profile"
  >
    <!-- profile info  -->
    <section
      v-if="user"
      id="profile-info"
    >
      <b-row>
        <!-- about suggested page and twitter feed -->
        <b-col
          lg="3"
          cols="12"
          order="2"
          order-lg="1"
        >
          <user-info-card :user="user" />
        </b-col>
        <!--/ about suggested page and twitter feed -->

        <!-- post -->
        <b-col
          lg="9"
          cols="12"
          order="1"
          order-lg="2"
        >
          <!--          <profile-post :posts="profileData.post" />-->
        </b-col>
        <!-- post -->

        <!-- load more  -->
        <b-col
          cols="12"
          order="4"
        />
        <!--/ load more  -->
      </b-row>
    </section>
    <!--/ profile info  -->

    <template v-else>
      <b-card>
        <b-skeleton
          animation="wave"
          width="85%"
        />
        <b-skeleton
          animation="wave"
          width="55%"
        />
        <b-skeleton
          animation="wave"
          width="70%"
        />
      </b-card>
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol, BSkeleton, BCard,
} from 'bootstrap-vue'

import api from '@/plugin/axios'
import UserInfoCard from './UserInfoCard.vue'

/* eslint-disable global-require */
export default {
  components: {
    BCard,
    BSkeleton,
    BRow,
    BCol,

    UserInfoCard,
  },
  data() {
    return {
      user: null,
    }
  },
  async created() {
    const [response] = await Promise.all([
      api.get(`/api/users/${this.$route.params.id}`),
    ])

    this.user = response.data
    console.log(this.user)
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss" >
@import '@core/scss/vue/pages/page-profile.scss';
</style>
